import {
  ComponentLabel,
  GridPosition,
  LayoutNames,
  RightWidgetConfiguration,
  WORKFLOW_POPUPS,
  WidgetNames,
  WorkflowWidgetConfig,
} from '@finxone-platform/shared/sys-config-types';

export class SetVisibleWidgetConfig {
  static readonly type = '[AppGrid] SetVisibleWidgetConfig';
  constructor(public visibleWidgetConfig: [RightWidgetConfiguration, GridPosition | null][]) {}
}

export class SetFooterVisibleWidgetConfig {
  static readonly type = '[AppGrid] SetFooterVisibleWidgetConfig';
  constructor(public footerVisibleWidgetConfig: [RightWidgetConfiguration, GridPosition | null][]) {}
}

export class SetActiveZone {
  static readonly type = '[AppGrid] SetActiveZone';
  constructor(public zone: string, public zoneType: string) {}
}

export class ClearContainerAndConfig {
  static readonly type = '[AppGrid] ClearContainerAndConfig';
}

export class SetCurrentCanvasComponent {
  static readonly type = '[AppGrid] SetCurrentCanvasComponent';
  constructor(
    public component: ComponentLabel,
    public zone?: string,
    public pageIndexOrSectionName?: number | string,
  ) {}
}

export class OpenPrivacyEditDialog {
  static readonly type = '[AppGrid] OpenPrivacyEditDialog';
  constructor(public fieldSlug: string, public header: string) {}
}

export class RemoveWidget {
  static readonly type = '[AppGrid] RemoveWidget';
  constructor(
    public widget: {
      index: number;
      uniqueId: string | number;
      screenName: string;
      isWidgetPage?: boolean;
    },
  ) {}
}

export class RemoveWidgetPage {
  static readonly type = '[AppGrid] RemoveWidgetPage';
  constructor(public widgetPage: { index: number; screenName: string }) {}
}

export class NewWidgetEvent {
  static readonly type = '[AppGrid] NewWidgetEvent';
  constructor(public widgetName: string, public id: string | number) {}
}

export class DragStartAction {
  static readonly type = '[AppGrid] DragStartAction';
  constructor(public draggedWidgetConfig: WorkflowWidgetConfig) {}
}

export class DroppedWidgetAction {
  static readonly type = '[AppGrid] DroppedWidgetAction';
  constructor(public widgetLayoutType?: LayoutNames | string | undefined) {}
}

export class DisplayPopupAction {
  static readonly type = '[AppGrid] DisplayPopupAction';
  constructor(public popupType: WORKFLOW_POPUPS | null) {}
}

export class CreatePopoutPreview {
  static readonly type = '[AppGrid] CreatePopoutPreview';
}

export class HighlightSelectedWidgets {
  static readonly type = '[AppGrid] HighlightSelectedWidgets';
  constructor(public widgetUniqueId: string | number, public multipleSelection?: boolean) {}
}

export class DeselectWidgets {
  static readonly type = '[AppGrid] DeselectWidgets';
}

export class WidgetTreeDroppedAction {
  static readonly type = '[AppGrid] WidgetTreeDroppedAction';
}

export class ReplaceImageAction {
  static readonly type = '[AppGrid] ReplaceImageAction';
  constructor(public uniqueId: string, public widgetNames: WidgetNames) {}
}
